import React, { useState } from "react";
import { Input, Form, Row, Col, Select, Typography, Button } from "antd";
import DeleteServicePopup from "../DeleteServicePopup";
import UploadImage from "../profile-components/steps/UploadImage";

const { TextArea } = Input;

const AddMoreServices = ({
  serviceData,
  handleServiceChange,
  handleUpdateServicesArr,
  onDelete,
  edit,
  ind,
  options,
  setLoader,
  SHOW_INFO
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = () => {
    setIsOpen(true);
  };

  const handleDeleteConfirmed = () => {
    setIsOpen(false);
    onDelete(serviceData.id);
  };

  const handleDeleteCancelled = () => {
    setIsOpen(false);
  };

  const handleInputChange = (value, name) => {
    const updatedServiceData = { ...serviceData, [name]: value };
    handleServiceChange(serviceData?._id || null, updatedServiceData, ind);
  };

  const handleUpdateImage = (name, value) => {
    const updatedServiceData = { ...serviceData, [name]: value };
    handleServiceChange(serviceData?._id || null, updatedServiceData, ind);
  };

  return (
    <div className="add-services-container">
      <Row>
        <Col span={24}>
          <div className="content position-relative mb-4">
            <div className="p-0 d-flex justify-content-center align-items-center image-upload">
              <UploadImage
                handleUpdateServicesArr={handleUpdateImage}
                IS_SERVICES
                currentImage={serviceData?.imgUrl}
                setLoader={setLoader}
              />
            </div>

            <div className="contentright">
              <div className="input1 w-100">
                <Form.Item
                  name={edit ? `service_name_edit-${ind}` : "service_name"}
                  className="w-75 me-3"
                  rules={[
                    {
                      required: true,
                      message: "Please enter service title",
                    },
                  ]}
                >
                  <Input
                    className="input-field email-input service-type-input"
                    placeholder="Service title"
                    maxLength={36}
                    defaultValue={serviceData?.title || ""}
                    onChange={(e) => handleInputChange(e.target.value, "title")}
                  />
                </Form.Item>

                <Form.Item
                  className="position-relative w-50"
                  label={false}
                  name={edit ? `subCategories_edit-${ind}` : "subCategories"}
                  rules={[
                    {
                      required: true,
                      message: "Please select your Sub Category!",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={
                      <img
                        src="/assets/icons/chevron-down-black.svg"
                        alt=""
                        className="img-fluid"
                      />
                    }
                    placeholder="Sub category"
                    onChange={(value) => handleInputChange(value, "subCatId")}
                    defaultValue={serviceData?.subCatName || null}
                    options={options}
                  />
                </Form.Item>

                <span onClick={handleDelete}>
                  <img
                    src="/assets/icons/deleteServiceIcon.svg"
                    alt="delete-service"
                    className="dlt-service-icon"
                  />
                </span>
              </div>

              <div className="input2 price-input w-100">
                <Form.Item
                  name={edit ? `service_fee_edit-${ind}` : "service_fee"}
                  className="col-12 mb-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter service fee",
                    },
                  ]}
                >
                  <Input
                    className="input-field service-type-fee"
                    placeholder="Service fee"
                    maxLength={4}
                    prefix="$"
                    defaultValue={serviceData?.price || ""}
                    onChange={(e) => handleInputChange(e.target.value, "price")}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <div className="col-24">
            <Form.Item
              name={
                edit ? `service_description_edit-${ind}` : "service_description"
              }
              rules={[
                {
                  required: true,
                  message: "Please input your service description",
                },
              ]}
            >
              <TextArea
                rows={4}
                className="text-area"
                placeholder="Service description"
                defaultValue={serviceData?.description || ""}
                onChange={(e) =>
                  handleInputChange(e.target.value, "description")
                }
              />
            </Form.Item>
          </div>
        </Col>
      </Row>

      {/* Preferred Slot Durations */}
      <Row className="mt-3">
        <Col span={24}>
          <Typography.Text strong>Preferred Slot Duration</Typography.Text>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              marginTop: "10px",
            }}
          >
            {[15, 30, 45, 60, 75, 90, 105, 120].map((duration) => (
              <Button
                key={duration}
                shape="round"
                type={
                  serviceData.preferredSlotDuration === duration
                    ? "primary"
                    : "default"
                }
                onClick={() =>
                  handleUpdateServicesArr("preferredSlotDuration", duration, ind)
                }
                style={{
                  background:
                    serviceData.preferredSlotDuration === duration
                      ? "linear-gradient(135deg, #2dd4bf, #3b82f6)"
                      : "#f0f2f5",
                  color:
                    serviceData.preferredSlotDuration === duration
                      ? "#fff"
                      : "#000",
                  border: "none",
                  fontWeight: 600,
                  height: "60px",
                  width: "109px",
                }}
              >
                {duration} mins
              </Button>
            ))}
          </div>
        </Col>
      </Row>

      {/* Max Bookings */}
      <Row className="mt-4">
        <Col span={24} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <Typography.Text>
            What are the maximum number of bookings you would accept for this
            service?
          </Typography.Text>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Button
              shape="circle"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                fontSize: "20px",
                fontWeight: "bold",
                margin: 0
              }}
              onClick={() => {
                const current = serviceData.maximumNumberOfBookings || 0;
                if (current > 0) {
                  handleUpdateServicesArr(
                    "maximumNumberOfBookings",
                    current - 1,
                    ind
                  );
                }
              }}
            >
                 <img
            src="/assets/icons/minus-filled.svg"
            alt="Minus"
          />
            </Button>

            <Typography.Text
              strong
              style={{ fontSize: '14px', minWidth: '10px', textAlign: 'center', whiteSpace: 'nowrap' }}
            >
              {serviceData.maximumNumberOfBookings || 0}
            </Typography.Text>

            <Button
              shape="circle"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#0E1E40",
                color: "#fff",
                border: "none",
                width: "36px",
                height: "36px",
                fontSize: "20px",
                fontWeight: "bold",
                margin: 0
                // paddingBottom: "4px",
              }}
              onClick={() => {
                const current = serviceData.maximumNumberOfBookings || 0;
                handleUpdateServicesArr(
                  "maximumNumberOfBookings",
                  current + 1,
                  ind
                );
              }}
            >
              <img
            src="/assets/icons/plus-filled.svg"
            alt="Plus"
          />
            </Button>
          </div>
        </Col>
      </Row>
      {SHOW_INFO &&
      <Row>
      <div className="col-12 mt-3">
                        <div
                          style={{
                            border: '2px solid #f9fafb',
                            borderRadius: '18px',
                            padding: '12px 12px 12px 12px',
                            marginTop: '16px',
                            color: '#6b7280',
                          }}
                        >
                          <img
                            src="/assets/icons/info-black.png"
                            alt="info"
                            style={{ width: '20px', marginRight: '10px', marginBottom: "10px"}}
                          />
                          <br />
                          <Typography.Text style={{color: "#777D88"}}>
                            If you prefer not to limit the number of bookings, set this value to 0. You'll receive every booking request we get.
                          </Typography.Text>
                        </div>
                      </div>
      </Row>}
      <DeleteServicePopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={handleDeleteConfirmed}
        onCancel={handleDeleteCancelled}
      />
    </div>
  );
};

export default AddMoreServices;
